// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3NTMy","errorLogs":"styles_errorLogs__hFYuj"};